/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PamDuplicateCandidateAddress
 */
export interface PamDuplicateCandidateAddress {
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidateAddress
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidateAddress
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidateAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidateAddress
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PamDuplicateCandidateAddress
     */
    line1: string;
}

/**
 * Check if a given object implements the PamDuplicateCandidateAddress interface.
 */
export function instanceOfPamDuplicateCandidateAddress(value: object): value is PamDuplicateCandidateAddress {
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('line1' in value) || value['line1'] === undefined) return false;
    return true;
}

export function PamDuplicateCandidateAddressFromJSON(json: any): PamDuplicateCandidateAddress {
    return PamDuplicateCandidateAddressFromJSONTyped(json, false);
}

export function PamDuplicateCandidateAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PamDuplicateCandidateAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'zip': json['zip'],
        'state': json['state'],
        'city': json['city'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'line1': json['line1'],
    };
}

export function PamDuplicateCandidateAddressToJSON(value?: PamDuplicateCandidateAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'zip': value['zip'],
        'state': value['state'],
        'city': value['city'],
        'line2': value['line2'],
        'line1': value['line1'],
    };
}

